import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import type { HTMLAttributes } from 'vue';
    import { cn } from '@/lib/utils';
    import { useVModel } from '@vueuse/core';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'Input',
  props: {
    defaultValue: {},
    modelValue: {},
    class: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

    const props = __props;

    const emits = __emit;

    const modelValue = useVModel(props, 'modelValue', emits, {
        passive: true,
        defaultValue: props.defaultValue,
    });

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("input", {
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(modelValue) ? (modelValue).value = $event : null)),
    "data-slot": "input",
    class: _normalizeClass(
            _unref(cn)(
                'file:text-foreground placeholder:text-faded-foreground/50 selection:bg-primary selection:text-primary-foreground border-input disabled:bg-muted flex h-7.5 w-full min-w-0 rounded-md border bg-transparent px-2.5 py-1 text-xs shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:border-0 file:bg-transparent file:pt-0.5 file:text-xs file:font-medium placeholder:text-xs',
                'disabled:bg-faded disabled:pointer-events-none disabled:cursor-not-allowed',
                'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
                props.class,
            )
        )
  }, null, 2)), [
    [_vModelText, _unref(modelValue)]
  ])
}
}

})